<h1 mat-dialog-title>{{ 'office_management.dialog_departments.title.departments' | translate }}</h1>

<div mat-dialog-content>

    <p>
        <mat-form-field class="full-width">
            <mat-label>{{ 'office_management.dialog_departments.lbl.assign_department' | translate }}</mat-label>
            <mat-select id="department_dialog.input_select.department"
                        [(ngModel)]="selectedUserAssignment"
                        [disabled]="disabled"
                        [panelClass]="'no-max-width'">
                <mat-option id="department_dialog.input_select.department.option_{{depIndex}}"
                            *ngFor="let assignment of data.userAssignments; let depIndex = index" [value]="assignment">
                    {{ assignment.display_name }}
                </mat-option>
            </mat-select>
            <mat-hint class="mat-error">{{ 'office_management.dialog_departments.hint' | translate }}</mat-hint>
        </mat-form-field>
    </p>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 offset-sm-6 no-gutters pr-0">
        <button id="department_dialog.btn.continue"
                mat-raised-button
                class="full-width"
                color="accent"
                [disabled]="!selectedUserAssignment"
                (click)="accept()">
            {{ 'common.btn.continue' | translate }}
        </button>
    </div>

</div>
